module.exports = __webpack_public_path__ + "static/img/vod-bn-7.e60a63a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-7.jpg
// module id = JITN
// module chunks = 1